// extracted by mini-css-extract-plugin
export var orderSummary = "_nj-0";
export var showMoreLessButton = "_nj-1";